import React from 'react';
import { CheckCircle2, Share2, Palette, GraduationCap } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Card, CardContent } from '../components/ui/card';
import { services, contactInfo } from '../utils/mockData';

export const ServicesSection = () => {
  const handleWhatsApp = (serviceTitle) => {
    const message = `Halo, saya tertarik dengan layanan ${serviceTitle}.`;
    const url = `https://wa.me/${contactInfo.whatsapp.replace(/[^0-9]/g, '')}?text=${encodeURIComponent(message)}`;
    window.open(url, '_blank');
  };

  const getIconComponent = (iconName) => {
    const icons = {
      Share2,
      Palette,
      GraduationCap
    };
    return icons[iconName] || Share2;
  };

  return (
    <section id="layanan" className="py-20 bg-gray-50 dark:bg-[#121212] scroll-mt-20">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Layanan Unggulan Kami
          </h2>
          <p className="text-lg text-gray-600 dark:text-gray-400 max-w-2xl mx-auto">
            Solusi lengkap untuk kebutuhan digital marketing Anda
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = getIconComponent(service.icon);
            return (
              <Card
                key={service.id}
                className="border border-gray-200 dark:border-gray-800 hover:shadow-xl hover:border-[#D32F2F]/50 transition-all duration-300 bg-white dark:bg-[#0F0F0F]"
              >
                <CardContent className="p-8 space-y-6">
                  <div className="w-14 h-14 rounded-xl bg-[#D32F2F]/10 flex items-center justify-center">
                    <IconComponent className="w-7 h-7 text-[#D32F2F]" />
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-3">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 dark:text-gray-400 leading-relaxed">
                      {service.description}
                    </p>
                  </div>
                  <ul className="space-y-2">
                    {service.features.map((feature, index) => (
                      <li key={index} className="flex items-start space-x-2">
                        <CheckCircle2 className="w-5 h-5 text-[#D32F2F] flex-shrink-0 mt-0.5" />
                        <span className="text-sm text-gray-600 dark:text-gray-400">{feature}</span>
                      </li>
                    ))}
                  </ul>
                  <Button
                    onClick={() => handleWhatsApp(service.title)}
                    variant="outline"
                    className="w-full border-[#D32F2F] text-[#D32F2F] hover:bg-[#D32F2F] hover:text-white"
                  >
                    {service.ctaText}
                  </Button>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
